import React from 'react';
import { Button } from '@framework-controls/core';
import css from './CalendarSelectAppt.module.scss';
import classNames from 'classnames';
import { Transportation } from 'src/models';
import { strings } from 'src/localization';

interface IProps {
    id: string;
    time: string;
    transportation: Transportation;
    label: string;
    timeHandler: (event: React.MouseEvent<HTMLElement, MouseEvent>, time: string, transportation: Transportation) => void;
    selected: boolean;
    theme: string;
}

const CalendarSelectApptTimeBtn = (props: IProps) => {
    const btnClassName = classNames(
        css.timeBtn,
        {
            [css.timeBtnChecked]: props.selected,
            [css.timeBtnCS]: props.theme === 'colorSensitive',
            [css.timeBtnCV]: props.theme === 'chevrolet' || props.theme === 'mercedesBenz',
            [css.timeBtnCA]: props.theme === 'cadillac',
            [css.timeBtnHonda]: props.theme === 'honda',
            [css.timeBtnBuick]: props.theme === 'buick',
            [css.timeBtnBMW]: props.theme === 'bmw',
            [css.timeBtnIN]: props.theme === 'infiniti',
            [css.timeBtnNissan]: props.theme === 'nissan',
            [css.timeBtnMazda]: props.theme === 'mazda',
            [css.timeBtnAcura]: props.theme === 'acura',
            [css.timeBtnGenesis]: props.theme === 'genesis',
        },
    );

    const timeHandler = (event: any) => {
        props.timeHandler(event, props.time, props.transportation);
    };

    let timeLit = props.label;
    if (props.transportation.type === 'N') {
        timeLit = strings.BeforeLit + props.label;
    }

    return (
        <div className={btnClassName}>
            <Button
                id={props.id + 'btn'}
                onClick={(event) => timeHandler(event)}
                type='text'
                variant='atext'
            >
                <span className={css.timeBtnContents}>{timeLit}</span>
            </Button>
        </div>
    );
};
export default CalendarSelectApptTimeBtn;